// import SchoolLevels from './screens/SchoolLevels';
import SchoolAttendance from './screens/SchoolAttendance';
import ReportList from './screens/Reports';

const routes = [
 
  {
    collapse: true,
      name: "Administración",
      icon: "nc-icon nc-briefcase-24",
      state: "adminCollapse",
      sidebar: true,
      roleID: ['ADMIN_MENU','FULL_CONFIG','TUTOR'] ,
      views: [
                {
                path: "/school-attendance",
                exact: true,
                name: "Asistencia",
                mini: "-",
                component: SchoolAttendance,
                layout: "/admin",
                sidebar: true,
                roleID: ['ATTENDANCE-REPORTS','TUTOR']
              }  ,
              {
                path: "/report-list",
                exact: true,
                name: "Reportes",
                mini: "-",
                component: ReportList,
                layout: "/admin",
                sidebar: true,
                roleID: ['REPORTS','TUTOR']
              } 
            
            ]
      }
] ;
  
  export default routes;